import {
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  RESET_EVENTS_STATE,
} from "../../../types/event";

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const deleteEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: "Event deleted successfully",
        success: true,
      };
    case DELETE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || "Failed to delete event",
        success: false,
      };
    case RESET_EVENTS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default deleteEventReducer;
